import CreateOrder from '@/pages/CreateOrder'

export default {
  path: '/create/order',
  name: 'Create Order',
  component: CreateOrder
}



// WEBPACK FOOTER //
// ./src/router/createorder.js